import { useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/ShoppingCart/Detail/Index';
import ProductContent from 'components/desktop/ShoppingCart/Detail/misc/ProductContent';
import ProductHeader from 'components/desktop/ShoppingCart/Detail/misc/ProductHeader';
import SearchInput from 'components/desktop/ShoppingCart/Detail/misc/SearchInput';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { Functor } from 'functions/Functor';
import useTranslation from 'hooks/useTranslation';
import { Product } from 'types/ShoppingCart/Product';
import { ProductList } from 'types/ShoppingCart/ProductList';

interface IProps extends RecipeErpViewComponentProps {}

const ProductTab = (props: IProps) => {
	const { classes } = useStyles();
	const { state, handlers, cart } = props;
	const { t, cc } = useTranslation();
	const [activeKey, setActiveKey] = useState('');

	const productItem = (product: Product.Type, j: number) => (
		<Accordion.Item eventKey={j.toString()} key={j}>
			<Accordion.Header
				className={`prodlist-effect ${
					activeKey === j.toString() ? 'side-border-effect' : ''
				}`}
			>
				<ProductHeader product={product}></ProductHeader>
			</Accordion.Header>
			<Accordion.Body
				style={{
					backgroundColor: '#fbfbfb',
				}}
			>
				<ProductContent product={product} {...props} />
			</Accordion.Body>
		</Accordion.Item>
	);

	return (
		<div className={classes.container}>
			<RenderIf condition={Boolean(cart.products.length)}>
				<SearchInput
					{...props}
					value={state.search.products}
					handleChange={handlers.setSearchProducts}
				/>
				<span className={classes.count}>
					{
						Functor.From(cart.products)
							.map((e) => ProductList.search(e, state.search.products, cc))
							.map(ProductList.group)
							.get().length
					}{' '}
					{t('shoppingCart:PRODUCTS')}
				</span>
				<Accordion activeKey={activeKey} onSelect={(key: any) => setActiveKey(key)}>
					{Functor.From(cart.products)
						.map((e) => ProductList.search(e, state.search.products, cc))
						.map(ProductList.group)
						.get()
						.map((product, i) => {
							return productItem(product, i);
						})}
				</Accordion>
			</RenderIf>
			<RenderIf condition={!cart.products.length}>
				<h4>{t('shoppingCart:NO_PRODUCTS')}</h4>
			</RenderIf>
		</div>
	);
};

export default ProductTab;

export const useStyles = tss.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		marginTop: '20px',
	},
	count: { fontWeight: 'lighter', fontStyle: 'italic' },
});
